<template>
    <div>
        <vtabs class="tabcard" type="card" v-model="activeIndex" style="font-size: 14px;">
            <vtab v-for="sc in filteredSaftyCheckItem" :key="sc.saftycheck" :title="sc.saftycheckname" :name="sc.saftycheck">
                <!-- <i v-if="activeIndex>0 && tab.calculate_relation" @click="syncPrevData(activeIndex)" class="el-icon-refresh-right" style="float: right;font-size: 22px;margin-right: 20px;padding: 10px 0px;color: #04A891;" title="同步上一步清点数据">同步</i> -->
                <div :style="{ height: `${screenHeight - 285}px` }" style="overflow-y: scroll;">
                    <div>
                        <template v-for="item in sc.items">
                            <div v-if="item.data_type != 'datetime'" :key="item.data_key">
                                <vdivider
                                    v-if="item.data_type != 'datetime' && item.name != ' '"
                                    :key="item.data_key"
                                    :margin="12"
                                    :style="{ color: '#04A891', borderColor: '#04A891', padding: '0 16px' }"
                                    >{{ item.name }}</vdivider
                                >
                                <vCheckboxGroup v-if="item.data_type == 'checkboxgroup'" v-model="AllDatas[`data_` + sc.saftycheck][item.data_key]" plain shape="square">
                                    <vCheckbox checked-color="#04A891" :name="o.value" :key="o.value" v-for="o in item.options" class="checkboxc" shape="square">{{ o.label }}</vCheckbox>
                                </vCheckboxGroup>

                                <vRadioGroup v-if="item.data_type == 'radio'" v-model="AllDatas[`data_` + sc.saftycheck][item.data_key]">
                                    <vRadio :name="o.value" :key="o.value" v-for="o in item.options" checked-color="#07c160" style="margin: 10px 0 0 20px;">{{ o.label }}</vRadio>
                                </vRadioGroup>
                                <vcellgroup v-if="item.data_type == 'string' || item.data_type == 'textarea'">
                                    <vfield type="textarea" v-model="AllDatas[`data_` + sc.saftycheck][item.data_key]" placeholder="请输入" rows="2" autosize maxlength="100" show-word-limit />
                                </vcellgroup>
                                <!-- @click="imgclick(sc.saftycheck,item.data_key)" -->
                                <!-- v-on:click="imgclick2222(sc.saftycheck,item.data_key) -->
                                <img
                                    v-if="item.data_key == 'doctor_name' || item.data_key == 'anesthesia_name' || item.data_key == 'nurse_name'"
                                    class="image_2"
                                    referrerpolicy="no-referrer"
                                    :src="AllDatas[`data_` + sc.saftycheck][item.data_key + '_sign']"
                                    @click="imgclick(sc.saftycheck, item.data_key)"
                                />
                            </div>
                        </template>
                    </div>
                </div>
                <div class="bottom">
                    <vbutton class="btnTrans" type="info" @click="checkedThrough(sc.saftycheck)">{{ AllDatas[`data_` + sc.saftycheck]['is_pass'] == true ? '保存' : '核对通过' }}</vbutton>
                    <vbutton class="btnTrans" type="info" v-if="AllDatas[`data_` + sc.saftycheck]['is_pass'] != true" style="background:#ea5a5a;" @click="checkedReject(sc.saftycheck)"
                        >核对不通过</vbutton
                    >
                </div>
            </vtab>
        </vtabs>
        <el-dialog :title="`${title}签名`" :close-on-click-modal="false" :visible.sync="showDialogVisible" width="100%" @close="handleClose">
            <iframe ref="qrcode" :src="signUrl" allow="microphone;camera;canvas" v-show="showDialogVisible" class="docframe width-p100" seamless :style="{ height: '500px' }"></iframe>
        </el-dialog>
    </div>
</template>
<script>
import {
    CellGroup as vcellgroup,
    Cell as vcell,
    PullRefresh as vpullrefresh,
    Stepper as vstepper,
    Field as vfield,
    Tab as vtab,
    Tabs as vtabs,
    NavBar as vnavbar,
    Empty,
    Button as vbutton,
    Dialog,
    Tabbar as vtabbar,
    Search as vsearch,
    TabbarItem as vtabbaritem,
    Icon as vicon,
    Tag as vtag,
    CheckboxGroup as vCheckboxGroup,
    Checkbox as vCheckbox,
    RadioGroup as vRadioGroup,
    Radio as vRadio,
    DatetimePicker as vdatetimepicker,
    Divider as vdivider
} from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
export default {
    name: `SaftyCheckMobile`,
    components: {
        vcellgroup,
        vpullrefresh,
        vcell,
        vstepper,
        vfield,
        vtab,
        vtabs,
        vnavbar,
        Empty,
        vtabbar,
        vtabbaritem,
        vbutton,
        [Dialog.Component.name]: Dialog.Component,
        vicon,
        vtag,
        vCheckboxGroup,
        vCheckbox,
        vsearch,
        vdatetimepicker,
        vdivider,
        vRadioGroup,
        vRadio
    },

    props: {
        surgeryId: Number,
        surgeryInfo: Object,
        visible: { type: Boolean }
    },
    data() {
        window.addEventListener(
            `message`,
            event => {
                if (event.data.action == `ok`) {
                    this.showDialogVisible = false
                    this.CaSignBody(event.data)
                } else {
                    // this.showDialogVisible = false
                }
            },
            false
        )
        return {
            title: `安全核查`,
            minDate: new Date(),
            message2: null,
            SaftyCheckItem: [],
            maxDate: new Date(2019, 10, 1),
            currentDate: new Date(),
            AllDatas: {},
            activeIndex: 0,
            result: [`a`, `b`],
            radio: `1`,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            token: this.$route.query.token,
            catoken: this.$route.query.catoken,
            permissions: [],
            isdesktop: false,
            toClose: true,
            currentList: [],
            showDialogVisible: false,
            useCa: this.$root.useCa,
            onlyRlsb: true,
            SaftyCheckUseCa: this.$root.SaftyCheckUseCa,
            caSignUrl: this.$root.CaSignUrl,
            caImagePath: this.$root.CaImagePath,
            saftyCheckReSign: this.$root.SaftyCheckReSign,
            saftyCheckVoiceMsg: this.$root.SaftyCheckVoiceMsg,
            saftyCheckVoiceTimeOut: this.$root.SaftyCheckVoiceTimeOut,
            isHide: true,
            query_enum_safty_check: this.$route.query.enum_safty_check,
            signUrl: ``,
            SafetyCheckWidth: 24,
            AllColumns: {},
            isShowSelectAllBtn: false, // 是否显示全选按钮
            isAlowEditCheckTime: false,
            isSelectedAll: {},
            AllCol: {},
            isSelectedKey: `AllSelect_P_`,
            selectAll: `security_check:selectAll`, // 全选权限
            msgDialogVisible: false,
            menuLeft: 0,
            menuTop: 0,
            speekmessage: ``,
            synth: null,
            msgsaftycheck: 0
        }
    },
    created() {
        this.$store.dispatch(`enums/ADD_ALL_ENUM`).then(() => {
            this.loadSaftyCheckItem()
        })
        // if (this.token) {
        //     sessionStorage.setItem(`token`, this.token)
        //     this.$store.dispatch(`ADD_WORKBAR`)
        // }
        // if (this.catoken) {
        //     sessionStorage.setItem(`caToken`, this.catoken)
        //     this.$store.dispatch(`ADD_WORKBAR`)
        // }
        // this.$store.dispatch(`enums/ADD_ALL_ENUM`).then(() => {
        //     this.loadSaftyCheckItem()
        // })
        // let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
        // req.then(permissions => {
        //     this.permissions = permissions

        //     this.isShowSelectAllBtn = _.find(permissions, { no: `security_check:selectAll` }) != undefined
        //     this.isAlowEditCheckTime = _.find(permissions, { no: `security_check:edit_checkTime` }) != undefined
        //     console.log(` this.isAlowEditCheckTime `, this.isAlowEditCheckTime)
        // }).then(data => {
        //     this.loadSaftyCheckItem()
        // })
    },
    mounted() {
        if (this.query_enum_safty_check != undefined && this.query_enum_safty_check != null) {
            this.isdesktop = true
        }
        this.synth = window.speechSynthesis
    },
    computed: {
        ...mapGetters([`currentUser`, `screenWidth`, `screenHeight`, `sys_enums`, `enum_menus`, `business`, `active_ward`]),
        filteredSaftyCheckItem() {
            console.log(`this.currentList`, this.currentList)
            console.log(`this.SaftyCheckItem`, this.SaftyCheckItem)
            if (this.currentList) {
                return this.SaftyCheckItem.filter(item => {
                    return item.saftycheck <= this.currentList.id
                })
            }
            return []
        }
    },
    methods: {
        handleClose() {
            // 处理关闭事件
            this.signUrl = ``
            console.log(`Dialog closed`)
        },
        ShowCard(check) {
            return false
            // if (this.query_enum_safty_check != undefined && this.query_enum_safty_check != null) {
            //     if (check == this.query_enum_safty_check) {
            //         return true
            //     }
            //     return false
            // } else {
            //     let index = check - 1
            //     if (this.unCheckedList && this.unCheckedList.indexOf(index) === -1) {
            //         return true
            //     }
            //     return false
            // }
        },
        init() {
            let that = this
            // 获取当前手术信息
            let req = this.myaxios.get(`/api/Operation/Home/Get?id=${this.surgeryId}`)
            let req1 = this.myaxios.get(`/api/Intraoperative/SaftyCheck/Records?surgeryInfoId=${this.surgeryId}`)
            let req2 = this.myaxios.get(`/api/AcisSystem/RecordTemplate/OccuredEvents?surgeryInfoId=${this.surgeryId}&recordType=1`)
            // 获取局麻事件列表
            let req3 = this.myaxios.get(`/api/AcisSystem/RecordTemplate/PartAnesEvents?surgeryInfoId=${this.surgeryId}&recordType=1`)
            this.myaxios.all(req, req1, req2, req3).then(([data, data1, data2, data3]) => {
                let events = data2.length == 0 ? data3 : data2
                let passData = _.filter(data1, { is_pass: true })
                console.log(`passData`, passData)
                _.reduce(
                    data1,
                    function(items, item, key) {
                        // 麻前检查时间获取进手术间时间
                        let startTime = (item && item.start_time) || (_.filter(events, { event_name: `进手术间` })[0] && _.filter(events, { event_name: `进手术间` })[0].occur_time)
                        let occurTime = item && item.check_date
                        let obj = {
                            id: item.id || 0,
                            biz_surgery_info_id: that.surgeryId,
                            enum_safty_check: item.enum_safty_check,
                            is_pass: item.is_pass,
                            check_date: item.check_date,
                            start_time: item.start_time,
                            safty_check_items: []
                        }
                        _.reduce(
                            item.safty_check_items,
                            function(result, value, key) {
                                // result[value.check_name] = value.check_value
                                if (
                                    value.check_name != `doctor_name` &&
                                    value.check_name != `anesthesia_name` &&
                                    value.check_name != `nurse_name` &&
                                    value.check_name != `start_time` &&
                                    value.check_name != `occur_time`
                                ) {
                                    let rfind = that.SaftyCheckItem.find(s => s.saftycheck == item.enum_safty_check)
                                    if (rfind) {
                                        let ritem = rfind.items.find(s => s.data_key == value.check_name)
                                        if (ritem) {
                                            if (ritem.data_type == `select` || ritem.data_type == `checkboxgroup` || ritem.data_type == `radio`) {
                                                obj[value.check_name] = value.check_value.split(`,`)
                                            }
                                        }
                                    }
                                }
                                if (!obj[value.check_name]) {
                                    obj[value.check_name] = value.check_value
                                }
                            },
                            {}
                        )
                        that.AllDatas[`data_` + item.enum_safty_check] = obj
                        if (!that.AllDatas[`data_` + item.enum_safty_check][`doctor_name`]) {
                            that.AllDatas[`data_` + item.enum_safty_check][`doctor_name`] = { value: item.surgeon, label: item.surgeon_name }
                        }
                        if (!that.AllDatas[`data_` + item.enum_safty_check][`anesthesia_name`]) {
                            that.AllDatas[`data_` + item.enum_safty_check][`anesthesia_name`] = { value: item.anesthesiologist, label: item.anesthesiologist_name }
                        }
                        if (!that.AllDatas[`data_` + item.enum_safty_check][`nurse_name`]) {
                            that.AllDatas[`data_` + item.enum_safty_check][`nurse_name`] = { value: item.circuit_nurse, label: item.circuit_nurse_name }
                        }
                        if (!that.AllDatas[`data_` + item.enum_safty_check][`start_time`]) {
                            that.AllDatas[`data_` + item.enum_safty_check][`start_time`] =
                                (startTime && that.$moment(startTime).format(`YYYY-MM-DD HH:mm`)) || that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                        }
                        if (!that.AllDatas[`data_` + item.enum_safty_check][`occur_time`]) {
                            that.AllDatas[`data_` + item.enum_safty_check][`occur_time`] =
                                (occurTime && that.$moment(occurTime).format(`YYYY-MM-DD HH:mm`)) || that.$moment(new Date()).format(`YYYY-MM-DD HH:mm`)
                        }
                        // that.changeDefaultShow(item.enum_safty_check)
                    },
                    {}
                )
                // 获取当前核查阶段
                let stage = _.map(passData, d => {
                    return d.enum_safty_check
                })
                console.log(stage)
                // 判断是否还有未核查的
                let r = _.filter(this.sys_enums.SaftyCheckStage, d => {
                    return stage.indexOf(d.value) === -1
                })

                if (r.length !== 0) {
                    this.currentList = {
                        id: r[0].value,
                        label: r[0].label
                    }
                } else {
                    this.currentList = {
                        id: this.sys_enums.SaftyCheckStage[stage.length - 1].value,
                        label: this.sys_enums.SaftyCheckStage[stage.length - 1].value.label
                    }
                }
                console.log(that.AllDatas)
                console.log(`currentList`, this.currentList)
                // 未核查记录
                this.unCheckedList = _.map(r, d => {
                    return d.value
                })
                // 赋值enum_safty_check到data里面
                // if (!that.AllDatas[`data_` + that.currentList.id][`enum_safty_check`]) {
                //     // that.AllDatas[`data_` + that.currentList.id][`enum_safty_check`] = that.currentList.id
                //     this.$set(that.AllDatas[`data_` + that.currentList.id], `enum_safty_check`, that.currentList.id)
                // }
                if (!this.isCaSign() && r.length !== 0) {
                    // ACIS-23527 已记录保存手术医生、巡回护士、麻醉医生情况下，各节点安全核查自动提取带出
                    if (!that.AllDatas[`data_` + that.currentList.id][`doctor_name`]) {
                        that.AllDatas[`data_` + that.currentList.id][`doctor_name`] = data.plan_surgeon_doctor
                    }
                    if (!that.AllDatas[`data_` + that.currentList.id][`anesthesia_name`]) {
                        that.AllDatas[`data_` + that.currentList.id][`anesthesia_name`] = data.plan_anes_doctor
                    }
                    if (!that.AllDatas[`data_` + that.currentList.id][`nurse_name`] && data.plan_circuit_nurse && data.plan_circuit_nurse.length > 0) {
                        that.AllDatas[`data_` + that.currentList.id][`nurse_name`] = data.plan_circuit_nurse[0]
                    }
                }
            })
        },
        checkedThrough(saftycheck) {
            this.saveData(saftycheck, true)
        },
        checkedReject(saftycheck) {
            this.saveData(saftycheck, false)
        },
        saveData(saftycheck, ispass) {
            let that = this
            let lists = this.getSaftyCheckItems(this.AllDatas[`data_` + saftycheck])
            let data = {
                id: 0 || 0,
                biz_surgery_info_id: this.surgeryId,
                enum_safty_check: saftycheck,
                is_pass: ispass,
                check_date: new Date(),
                start_time: new Date(),
                safty_check_items: lists
            }
            console.log(`data`, data)
            if (this.isCaSign() == true) {
                let surgeon = that.AllDatas[`data_${saftycheck}`][`doctor_name`]
                let anesthesiologist = that.AllDatas[`data_${saftycheck}`][`anesthesia_name`]
                let circuitnurse = that.AllDatas[`data_${saftycheck}`][`nurse_name`]
                data.surgeon = (surgeon && surgeon.value) || undefined
                data.surgeon_name = (surgeon && surgeon.label) || undefined
                data.anesthesiologist = (anesthesiologist && anesthesiologist.value) || undefined
                data.anesthesiologist_name = (anesthesiologist && anesthesiologist.label) || undefined
                data.circuit_nurse = (circuitnurse && circuitnurse.value) || undefined
                data.circuit_nurse_name = (circuitnurse && circuitnurse.label) || undefined
            } else {
                // data.surgeon = (formdata[`doctor_name`] && formdata[`doctor_name`].value) || undefined
                // data.anesthesiologist = (formdata[`anesthesia_name`] && formdata[`anesthesia_name`].value) || undefined
                // data.circuit_nurse = (formdata[`nurse_name`] && formdata[`nurse_name`].value) || undefined
                // data.surgeon_name = (formdata[`doctor_name`] && formdata[`doctor_name`].label) || undefined
                // data.anesthesiologist_name = (formdata[`anesthesia_name`] && formdata[`anesthesia_name`].label) || undefined
                // data.circuit_nurse_name = (formdata[`nurse_name`] && formdata[`nurse_name`].label) || undefined
            }
            // 判断空条件
            if (data.surgeon === undefined || data.surgeon_name === undefined) {
                this.$message.warning(`手术医生确认不能为空`)
                return
            }
            // 局麻手术 有些情况会没有麻醉医生，不用判断麻醉医生必填
            if (!that.surgeryInfo.is_local_anes && (data.anesthesiologist === undefined || data.anesthesiologist_name === undefined)) {
                this.$message.warning(`麻醉医生确认不能为空`)
                return
            }
            if (data.circuit_nurse === undefined || data.circuit_nurse_name === undefined) {
                this.$message.warning(`巡回护士确认不能为空`)
                return
            }
            console.log(this.SaftyCheckItem)
            let chs = _.cloneDeep(this.SaftyCheckItem)
            let t2 = chs.find(s => s.saftycheck == saftycheck)
            let sussmessage = ``
            if (t2 != null) {
                sussmessage = t2.saftycheckname
            }

            let req = that.myaxios.post(`/api/Intraoperative/SaftyCheck/Records`, data)
            req.then(data => {
                if (ispass) {
                    this.$message.success(sussmessage + `保存成功`)
                } else {
                    this.$message.warning(sussmessage + `核对不通过`)
                }

                that.init()
            }).catch(e => {
                console.log(e)
            })
        },
        imgclick(saftycheck, datakey) {
            console.log(111, saftycheck)
            console.log(222, datakey)
            // this.$set(this.AllDatas[`data_1`], `doctor_name_sign`, `http://10.100.10.206:9713/templates/images/zx001.png`)

            let datas = this.getSaftyCheckItems(this.AllDatas[`data_` + saftycheck])
            let r = JSON.stringify(datas)
            console.log(`r`, r)
            let url = `${this.caSignUrl}?app_key=${this.$root.appKey}&ca_token=`
            let caToken = sessionStorage.getItem(`caToken`)
            if (caToken) url = `${url}${caToken}`
            var random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
            let rcode = ``
            for (var i = 0; i < 8; i++) {
                // 设置随机数范围,这设置为0 ~ 36
                var index = Math.floor(Math.random() * 9)
                // 字符串拼接 将每次随机的字符 进行拼接
                rcode += random[index]
            }
            this.myaxios
                .post(url, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: {
                        biz_id: this.surgeryId + `|` + saftycheck + `|` + datakey + `|` + rcode,
                        raw_data: r
                    }
                })
                .then(signUrl => {
                    console.log(signUrl)
                    this.signUrl = signUrl + `&type=${datakey}&onlyRlsb=${this.onlyRlsb}`
                    this.showDialogVisible = true
                })
        },
        CaSignBody(data) {
            let that = this
            let bizdata = data.data
            let req = that.myaxios.get(`/api/AcisSystem/Authorization/GetAcUserByUserCode?username=${bizdata.username}`)
            req.then(user => {
                let bizs = bizdata.biz_id.split(`|`)
                if (bizs.length >= 1) {
                    let enumsaftycheck = bizs[1]
                    let proname = bizs[2]
                    this.$set(that.AllDatas[`data_` + enumsaftycheck], proname + `_sign`, `${this.caImagePath}/${bizdata.username}.png`)
                    // if (b.data_key == `doctor_name` || b.data_key == `anesthesia_name` || b.data_key == `nurse_name`)
                    if (proname.indexOf(`doctor_name`) > -1) {
                        this.$set(that.AllDatas[`data_` + enumsaftycheck], `doctor_name`, { label: user.dic_worker_name, value: user.dic_worker_id })
                    } else if (proname.indexOf(`anesthesia_name`) > -1) {
                        this.$set(that.AllDatas[`data_` + enumsaftycheck], `anesthesia_name`, { label: user.dic_worker_name, value: user.dic_worker_id })
                    } else if (proname.indexOf(`nurse_name`) > -1) {
                        this.$set(that.AllDatas[`data_` + enumsaftycheck], `nurse_name`, { label: user.dic_worker_name, value: user.dic_worker_id })
                    }
                    console.log(`CaSignBody`, that.AllDatas)
                    this.changeimgstatus(enumsaftycheck)
                    // 这里更改一下这个参数，用来触发一下create,不然图片会不刷新
                    // that.SaftyCheckUseCa = 0
                    // that.SaftyCheckUseCa = 1
                }
            })
        },
        changeimgstatus(saftycheck) {
            this.$set(this.AllDatas[`data_` + saftycheck], `enum_safty_check`, `0`)
            this.$set(this.AllDatas[`data_` + saftycheck], `enum_safty_check`, saftycheck)
        },
        getSaftyCheckItems(row) {
            let that = this
            console.log(`row`, row)
            let lists = _.reduce(
                row,
                function(result, value, key) {
                    let type = typeof value
                    if (value !== undefined && value !== null && key !== `origion` && !_.endsWith(key, `doctor_name`) && !_.endsWith(key, `anesthesia_name`) && !_.endsWith(key, `nurse_name`)) {
                        result.push({
                            id: 0,
                            biz_safty_check_id: that.currentList.id,
                            check_name: key,
                            check_value: type === `object` ? value.toString() : value
                        })
                    }
                    return result
                },
                []
            )
            return lists
        },
        loadSaftyCheckItem() {
            let that = this
            if (!this.surgeryId) return
            this.myaxios
                .get(`/api/AcisSystem/DicSaftyCheckItem/Get`)
                .then(data => {
                    // console.log(`data`, data)
                    let saftychecks = []
                    console.log(`data111`, data)
                    _.map(data, d => {
                        if (d.data_type == `select` || d.data_type == `checkboxgroup` || d.data_type == `radio`) {
                            console.log(`options`, d.data_option)
                            d.options = JSON.parse(d.data_option)
                        }
                        _.map(d.safty_check_stages, f => {
                            if (!saftychecks.includes(f)) {
                                saftychecks.push(f)
                            }
                        })
                    })
                    console.log(saftychecks)
                    let objs = []
                    saftychecks = saftychecks.sort((a, b) => a.display_order - b.display_order)
                    _.map(saftychecks, saftycheck => {
                        let saftycheckname = ``
                        let saftycheckobj = this.sys_enums && this.sys_enums.SaftyCheckStage && this.sys_enums.SaftyCheckStage.find(f => f.value == saftycheck)
                        if (saftycheckobj) {
                            saftycheckname = saftycheckobj.label
                        }
                        let r = {
                            saftycheck: saftycheck,
                            saftycheckname: saftycheckname,
                            items: null
                        }
                        let find = data.filter(s => s.safty_check_stages.includes(saftycheck))

                        if (find) {
                            find = find.sort((a, b) => a.display_order - b.display_order)
                            r.items = find
                        }
                        this.$set(that.AllDatas, `data_` + saftycheck, {})
                        console.log(r)
                        that.setcolumns(saftycheck, r)
                        objs.push(r)
                        this.isSelectedAll[this.isSelectedKey + saftycheck] = undefined
                        // this.AllDatas[`data_` + saftycheck] = undefined
                    })
                    if (objs && objs.length > 0) {
                        this.SafetyCheckWidth = 24 / objs.length
                    }
                    this.SaftyCheckItem = objs

                    // console.log(`isSelectedAll`, this.isSelectedAll)
                })
                .then(inits => {
                    console.log(`123`, that.AllDatas)
                    this.init()
                    // this.init()
                })
        },
        setcolumns(saftycheck, obj) {
            // prop生成规则   safty_{saftycheck}_{data_key}
            let that = this
            let columns = []
            let saftyCheckmodel = _.cloneDeep(obj)
            if (saftyCheckmodel.items && saftyCheckmodel.items.length > 0) {
                let items = saftyCheckmodel.items.sort((a, b) => a.display_order - b.display_order)
                let allKeys =
                    _.filter(items, d => {
                        return d.is_show == true && d.rel_keys != null && d.rel_keys != `` && d.default_value != null
                    }) || []
                let keys = []
                _.forEach(allKeys, k => {
                    let relKeys = eval(`(` + k.rel_keys + `)`)
                    let item = _.find(relKeys, x => x.value == k.default_value)
                    let okeys = (item && item.DataKeys && item.DataKeys.split(`,`)) || []
                    keys = [...keys, ...okeys]
                })
                _.forEach(items, b => {
                    let cm = {}

                    if (b.data_required == true) {
                        cm.validate = [{ required: true, message: `必填项目`, trigger: `blur` }]
                    }
                    // 初始化好，data结构，防止页面不重新渲染
                    this.$set(that.AllDatas[`data_` + saftycheck], b.data_key, undefined)
                    // if (b.data_key == `start_time` || b.data_key == `occur_time`) {
                    //     if (this.isAlowEditCheckTime) {
                    //         cm.readonly = false
                    //     } else {
                    //         cm.readonly = true
                    //     }
                    // }

                    if (b.data_type == `remoteselect` || b.data_type == `remotemultiselect` || b.data_type == `remoteselecttable`) {
                        if (b.data_key == `doctor_name` || b.data_key == `anesthesia_name` || b.data_key == `nurse_name`) {
                            cm.change = null
                            if (!this.isCaSign()) {
                                cm.options = (that2, { row }) => {
                                    return q => {
                                        let r = that.myaxios.get(`/api/AcisSystem/SurgeryInfoExtraParam/SearchOptionsIntByKey?sql=${b.data_option}`, q)
                                        return r
                                    }
                                }
                            } else {
                                // 重新生成prop
                                cm.prop = b.data_key + `_sign`
                                cm.type = `img`

                                this.$set(that.AllDatas[`data_` + saftycheck], cm.prop, undefined)
                            }
                        }
                    }
                    columns.push(cm)
                })
            }

            // 给data增加enum_safty_check，后续会用到
            this.$set(that.AllDatas[`data_` + saftycheck], `enum_safty_check`, saftycheck)
            this.AllColumns[`data_` + saftycheck] = columns
            console.log(`data_`, this.AllColumns[`data_` + saftycheck])
        },
        isCaSign() {
            if (this.useCa == `1` && this.SaftyCheckUseCa == `1`) {
                return true
            }
            return false
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadSaftyCheckItem()
        }
    },
    destroyed() {
        let that = this
        that.isHide = false
        if (that.synth.speaking) {
            that.synth.cancel()
        }
    }
}
</script>
<style lang="less" scoped>
@import '../mobile_common.css';
.backbar {
    background-color: #04a891;
    border: unset !important;
    /deep/ .van-icon {
        color: #ffffff !important;
    }
    /deep/ .van-nav-bar__text {
        color: #ffffff !important;
    }
    /deep/ .van-nav-bar__title {
        color: #ffffff !important;
    }
}
.checkboxc {
    margin: 10px 0 0 20px;
}
.tabcard /deep/ .van-tabs__nav {
    display: -webkit-box;
}
.tabcard /deep/ .van-tab {
    color: #04a891;
    border-right: 1px solid #04a891;
}
.tabcard /deep/ .van-tab--active {
    color: #fff;
    background-color: #04a891;
}
.tabcard /deep/ .van-tabs__nav--card {
    border: 1px solid #04a891;
}
.image_2 {
    width: 60px;
    height: 60px;
    margin: 5px 0 6px 0;
}
.bottom {
    display: flex;
    position: fixed;
    bottom: 0px;
    width: 100%;
    .btnTrans {
        flex: 1;
        background: var(--primary-color, #009688);
        margin: 5px;
        height: 40px;
        padding: 0px 30px;
        color: #ffffff;
    }
}
</style>
<style scoped>
#div1 {
    position: relative;
}
#div2 {
    position: relative;
    left: 20px;
}
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
h3 {
    margin: 0;
}

.card-content /deep/ .safecheck_p3_gzgl .el-form-item__content div label:nth-last-child(1) {
    display: block;
}

.card-content /deep/ .safecheck_p3_gzgl .el-form-item__label {
    width: 100%;
    display: flex;
}

.card-content /deep/ .el-form-item__content {
    line-height: 35px !important;
}

.card-content /deep/ .safecheck_p3_gzgl_qt_text {
    width: 120px;
    position: absolute;
}

/* position: relative;
    right: -220px;
    top: -52px; */

.card-content /deep/ .safecheck_p3_gzgl_qt_text .el-form-item__content {
    margin-left: 10px !important;
    position: relative;
    top: -46px;
    left: 80px;
}
.speekmessage {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 800px;
    height: 200px;
    color: #ffffff;
    background-image: linear-gradient(#ee0262, #650133);
    z-index: 999;
    border-radius: 10px;
    margin-top: -100px;
    margin-left: -400px;
    font-size: 48px;
}
.note {
    height: 50%;
    line-height: 200px;
}
.active {
    display: none;
}
</style>
<style lang="less">
.handover-nurse .el-timeline-item__node {
    cursor: pointer;
    z-index: 2;
    &:hover {
        width: 20px;
        height: 20px;
        left: -6px;
        top: -6px;
        background: #409eff;
    }
}
// .safecheck_p1_gms  {
//   label.el-form-item__label{
//     color:red !important;
//   }
// }
.menu_box {
    position: fixed;
    z-index: 1004;
    background-color: #fff;
    // border-radius: 5px;
    .menu {
        width: 100px;
        text-align: left;
        // padding: 5px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .menu_item {
            height: 24px;
            line-height: 22px;
            // margin-top: 5px;
        }
        .item_text {
            color: #171a1d;
            cursor: pointer;
            padding: 4px 20px;
            // border-radius: 3px;
            transition: all 0.2s ease-in;
        }
        .item_text:hover {
            background-color: #e9eaec;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile/SaftyCheck/SaftyCheckMobile.vue